import {Component, OnInit, ViewChild} from '@angular/core';
import {ThresholdsListComponent} from './thresholds-list/thresholds-list.component';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';

@Component({
  selector: 'thresholds',
  templateUrl: './thresholds.component.html',
  styleUrls: ['./thresholds.component.scss']
})
export class ThresholdsComponent implements OnInit {

  @ViewChild(ThresholdsListComponent, {static: true}) thresholdsListComponent;

  selectedThreshold;
  isAuthorized: boolean;

  constructor(private userPrivilege: UserPrivilegeService,) { }

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();
  }

  onThresholdSelection(selectedThreshold: string): void {
    this.selectedThreshold = selectedThreshold;
  }

  onThresholdChange(threshold): void {
    this.thresholdsListComponent.getThreshold();
  }

  addThreshold(): void {
    this.thresholdsListComponent.addThreshold();
  }

  deleteThreshold(): void{
    this.thresholdsListComponent.deleteThreshold();
  }

  refreshThreshold(): void {
    this.thresholdsListComponent.refreshThreshold();
  }
  showAddIcon(): boolean {
    return this.thresholdsListComponent.showAddIcon();
  }

}
